import { promise } from '../../../helpers';
import { updateGroupsParticipantsItem } from './index';

const updateGroupsParticipantsItems = props => {
    const { where } = props;

    if (where) {
        return updateGroupsParticipantsItem(props);
    }

    return promise();
};

export default updateGroupsParticipantsItems;
